import React from "react";
import { defineMessages } from "react-intl";
import { ApolloConsumer } from "react-apollo";
import styled, { ThemeProvider } from "styled-components/native";
import { AppProvider } from "cci-logic";
import ProgressDialog from "../dialog/ProgressDialog";
import Alert from "../dialog/message/Alert";
import { GlobalStyle } from "../icon/GlobalStyle";

const messages = defineMessages({
  restablishingConnection: {
    id: "Error.restablishingConnection",
    defaultMessage: "Restablishing connection with server..."
  },

  notActionAuthorized: {
    id: "Error.notActionAuthorized",
    defaultMessage: "You are not authorized to perform this action."
  },
});

/* Gives us the application background color while the loader component is shown */
const Wrapper = styled.View`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${props => props.theme.pageBackgroundColor};
`;

/**
 * Base component for all apps that require connection to a GraphQL backend.
 * 
 * This component shows a progress alert when connection is being established as well as any authorization error.
 */
const AppBase = props => (
  <ThemeProvider theme={props.theme}>
    {/* Icons added */}
    <GlobalStyle />

    <AppProvider
      loaderComponent={<Wrapper><ProgressDialog isVisible={true} /></Wrapper>}
      globalComponents={connectionInfo => (
        <ApolloConsumer>{client => (
          <React.Fragment>
            {/* Loading indicator, used for Apollo requests */}
            <ProgressDialog
              isVisible={connectionInfo.loading}
            />

            {/* Shown when the server has not responded to our request */}
{/*
            <Alert
              show={connectionInfo.connectionLost}
              showProgress={true}
              message={messages.restablishingConnection}
            />
*/}

            {/* Shown when the server throws an an Access Denied exception */}
            <Alert
              isVisible={connectionInfo.authorizationFailed}
              message={messages.notActionAuthorized}
              onConfirm={() => client.writeData({
                data: {
                  ConnectionInfo: {
                    __typename: "ConnectionInfo",
                    authorizationFailed: false
                  }
                }
              })}
            />
          </React.Fragment>
        )}</ApolloConsumer>
      )}
      {...props}
    />
  </ThemeProvider>
);

AppBase.defaultProps = {
  theme: {}
};

export default AppBase;
